// eslint-disable-next-line import-x/no-named-as-default
import DS from 'ember-data';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import { BillingQuotePeriod } from 'uplisting-frontend/models/billing-quote';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BillingQuoteRepositoryService extends BaseRepositoryService<
  ModelRegistry['billing-quote']
> {
  recordName = 'billing-quote';
  implementMethods = ['query', 'unloadRecords', 'peekAll', 'unloadAll'];

  // Every billing screen needs both periods for a single currency.
  queryForCurrency(
    currency: string,
  ): Promise<DS.PromiseArray<ModelRegistry['billing-quote']>> {
    return this.query({
      currency,
      periods: [BillingQuotePeriod.annual, BillingQuotePeriod.monthly],
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/billing-quote': BillingQuoteRepositoryService;
  }
}
